// @core/stores/apikey/ApikeyApikeyStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { apikeyApi } from '@core/api';
import type {
  RecordAPIKeyUsageRequest,
  ValidateAPIKeyRequest,
  ValidateAPIKeyResponse,
} from '@core/types/apikey';

class ApikeyApikeyStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Record a p i key usage
   */
  async RecordAPIKeyUsage(data: RecordAPIKeyUsageRequest): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await apikeyApi.RecordAPIKeyUsage(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Validate a p i key
   */
  async ValidateAPIKey(data: ValidateAPIKeyRequest): Promise<ValidateAPIKeyResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await apikeyApi.ValidateAPIKey(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const apikeyApikeyStore = new ApikeyApikeyStore();
